<template>
  <div class="video-container">
    <iframe
      id="video-holder"
      :src="this.activeVideo"
      frameborder="0"
      width="1920"
      height="1080"
      allow="autoplay; encrypted-media"
      allowfullscreen="true"
      webkitallowfullscreen="true"
      mozallowfullscreen="true"
    ></iframe>
  </div>
</template>

<script>
import { setInterval } from "timers";

// const avp1 = 'https://firebasestorage.googleapis.com/v0/b/galaga-board.appspot.com/o/AVP%201st%20part.mp4?alt=media&token=45684c23-eaa0-4140-9304-b59df4b39296';
// const teaser = 'https://firebasestorage.googleapis.com/v0/b/galaga-board.appspot.com/o/Teaser.mp4?alt=media&token=53f5c812-fb5d-4deb-b143-65712cce61e1';

const avp1 = "https://www.youtube.com/embed/o0IADUntyYA?autoplay=1&rel=0";
const teaser = "https://www.youtube.com/embed/fWXEimSPXY4?autoplay=1&rel=0";

// var videoIDs = ["o0IADUntyYA", "fWXEimSPXY4"];

// var player,
//   currentVideoId = 0;

// function onYouTubeIframeAPIReady() {
//   player = new YT.Player("player", {
//     height: "350",
//     width: "425",
//     events: {
//       onReady: onPlayerReady,
//       onStateChange: onPlayerStateChange
//     }
//   });
// }

// function onPlayerReady(event) {
//   event.target.loadVideoById(videoIDs[currentVideoId]);
// }

// function onPlayerStateChange(event) {
//   if (event.data == YT.PlayerState.ENDED) {
//     currentVideoId++;
//     if (currentVideoId < videoIDs.length) {
//       player.loadVideoById(videoIDs[currentVideoId]);
//     }
//   }
// }

export default {
  name: 'VideoPlayer',
  data() {
    return {
      activeVideo: '',
      timer: 0
    }
  },
  watch: {
    timer: {
      immediate: true,
      handler(val) {
        console.log(val);
        if (val === 0)
          this.activeVideo = avp1;
        else if (val >= 70)
          this.activeVideo = teaser;
      }
    }
  },
  mounted() {
    setInterval(() => {
      this.timer++;
    }, 1000);
  }
}
</script>

<style scoped>
.video-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

iframe {
  /* optional */
  width: 100%;
  height: 100%;
}
</style>